"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const filter_1 = __importDefault(require("lodash/filter"));
const get_1 = __importDefault(require("lodash/get"));
/**
 * Returns transmission for the fleet group
 */
const getTransmission = (features, language) => {
    const filteredArr = (0, filter_1.default)(features, (feature) => {
        return (0, get_1.default)(feature, 'name.en').toLowerCase() === 'transmission';
    });
    return (0, get_1.default)(filteredArr, `0.value.${language}`, '');
};
exports.default = getTransmission;
